import Vue from 'vue'
import Vuex from 'vuex'
import tableData from './modules/tableData'
import pageData from './modules/pageData'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ // 配置持久化本地存储
    paths: ['tableData', 'pageData' ] // 配置持久化存储
  })],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    tableData,
    pageData
  }
})
